import { useRouter } from 'next/router';
import { globalDataStore } from '@/dashboard/store/globalDataStore';
import { getHomePolicysPath } from '@/dashboard/utils/routes';
import qs from 'qs';

export const usePageJump = () => {
  const router = useRouter();
  const {
    state: { queryParams },
  } = globalDataStore();
  const jumpToHomePage = () => {
    router.replace(
      `${getHomePolicysPath()}${
        !!queryParams ? '?' + qs.stringify(queryParams) : ''
      }`
    );
  };

  return {
    jumpToHomePage,
  };
};
